<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs9>
        <v-combobox
          v-model="namespace"
          class="mb-4"
          :hint="$t('hint')"
          :items="namespaces"
          :label="$t('label')"
          :rules="namespaceRules"
          @change="setNamespace"
          persistent-hint
          required
        >
        </v-combobox>
      </v-flex>
      <v-flex class="ml-2 mt-3" xs2>
        <v-btn
          color="primary"
          @click="createNamespace(namespace)"
          :disabled="namespaces.includes(namespace) || !validateNamespace(namespace)"
          :loading="pending"
          small
        >
          {{ $t('notice.create') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NetworkService from '@/services/network'

export default {
  data () {
    return {
      namespace: undefined,
      namespaces: [],
      namespaceRules: [
        (n) => !!n || this.$t('error.namespace_required'),
        (n) => this.validateNamespace(n) || this.$t('error.namespace_invalid')
      ],
      pending: false
    }
  },
  created () {
    this.fetchNamespaces()
  },
  methods: {
    createNamespace (namespace) {
      if (namespace && this.validateNamespace(namespace)) {
        this.pending = true
        NetworkService.createNamespace(namespace).then(() => {
          this.fetchNamespaces()
        }).then(() => {
          this.$emit('namespaceExist', 'Declare that the namespace exists now.')
        }).finally(() => {
          this.pending = false
        })
      }
    },
    fetchNamespaces () {
      NetworkService.namespaces().then((data) => {
        const values = data.slice()
        if (values[0]) {
          this.namespace = values[0]
        }
        this.namespaces = values
        const currentNamespace = values.find((n) => n === this.namespace)
        if (currentNamespace) {
          this.setNamespace(currentNamespace)
        }
      })
    },
    setNamespace (namespace) {
      this.$store.commit('setNamespace', namespace)
      if (this.namespaces.includes(namespace)) {
        this.$emit('namespaceExist', 'Declare that the namespace exists.')
      }
      this.$emit('fetchTokens', 'Fetch token for selected namespace.')
    },
    validateNamespace (namespace) {
      return /^[a-zA-Z0-9._-]{1,32}$/.test(namespace)
    }
  },
  props: {
  },
  computed: {
    wizard () {
      return this.$store.state.wizardModule.wizard
    },
    namespaceStore () {
      return this.wizard.selectedNamespace
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "label": "Select the namespace(s)",
    "hint": "Your Unryo system can be composed of multiple namespaces so that your data is segmented. Select the namespace carefully, as it may impact data security.",
    "notice": {
      "create": "Create"
    },
    "error": {
      "namespace_required": "The namespace is required.",
      "namespace_invalid": "It must be at most 32 characters long and only contain letters, numbers, dots, dashes and underscores."
    }
  }
}
</i18n>
